import { render, staticRenderFns } from "./ApiBridgeRegisterForm.vue?vue&type=template&id=24deb4be&scoped=true&"
import script from "./ApiBridgeRegisterForm.vue?vue&type=script&lang=js&"
export * from "./ApiBridgeRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./ApiBridgeRegisterForm.vue?vue&type=style&index=0&id=24deb4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24deb4be",
  null
  
)

export default component.exports